import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  applyFilters(e) {
    e.preventDefault();

    if($(".filters-form").valid()) {
      $('.calls-datatable').DataTable().ajax.reload()
    }
  }
}